import React from 'react';
import { JobTabProps } from '../types';

export const Overview: React.FC<JobTabProps> = ({ job: jobProp }) => {
  //TODO complete that when we decide to add overview tab
  return <div>Name: {jobProp.Name}</div>;
};

export default Overview;
